import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { DialogWidth, UserExistsByEmail } from 'types';
import ClosureErrorIcon from '../../Icons/ClosureErrorIcon';
import NewDialog from '../../NewDialog';

const useStyles = makeStyles(theme => ({
  content: {
    marginBottom: '32px',
    marginRight: '32px',

    '& p': {
      fontSize: 16,
      lineHeight: '24px',
      textAlign: 'left',
      verticalAlign: 'top',
    },
    '& p span': {
      color: '#FF9500',
    },
  },
  bottomButton: {
    textAlign: 'right',
  },
  closeIcon: {
    width: '16px',
  },
  continueIcon: {
    width: '16px',
  },
  continueButton: {
    backgroundColor: '#2F3741',
    color: '#FFFFFF',
    marginLeft: theme.spacing(2),

    '&:hover': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
    '&:active': {
      color: '#2F3741',
      '& *': {
        color: '#2F3741',
      },
    },
  },
}));

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  userExistByEmail?: UserExistsByEmail | null;
  handleCancel?: () => void;
  handleContinue?: () => void;
  labelContinue?: string | null;
}

export const DialogUserExistsAndNotBelongToAdmin: React.FC<Props> = ({
  isOpen,
  setOpen,
  userExistByEmail,
  handleContinue,
  handleCancel,
  labelContinue,
}) => {
  const classes = useStyles();

  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });

  const handleDefaultCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <NewDialog
        closable={true}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        width={DialogWidth.LARGE_FORM}
        title={t('dialogUserExists.title')}
        renderContent={() => (
          <>
            <div className={classes.content}>
              <Typography>{t('dialogUserExists.noBelongToAdminText1')}</Typography>
              <Typography>
                <span>
                  {userExistByEmail && userExistByEmail.user?.firstName}{' '}
                  {userExistByEmail && userExistByEmail.user?.lastName}
                </span>
              </Typography>
              <Typography>
                <span>{userExistByEmail && userExistByEmail.user?.email}</span>
              </Typography>
              <br />
              <Typography>{t('dialogUserExists.noBelongToAdminText2')}</Typography>
            </div>
          </>
        )}
        renderFooter={() => (
          <>
            <div className={classes.bottomButton}>
              <Button
                variant="outlined"
                startIcon={<ClosureErrorIcon className={classes.closeIcon} />}
                onClick={handleCancel ? handleCancel : handleDefaultCancel}
              >
                {t('dialogUserExists.cancel')}
              </Button>
              {handleContinue && (
                <Button
                  className={classes.continueButton}
                  variant="outlined"
                  endIcon={<ArrowForwardIcon className={classes.continueIcon} />}
                  onClick={handleContinue}
                >
                  {labelContinue ? labelContinue : t('dialogUserExists.continue')}
                </Button>
              )}
            </div>
          </>
        )}
      />
    </>
  );
};
